import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=4527f2f3&scoped=true"
import script from "./TaskTable.vue?vue&type=script&lang=js"
export * from "./TaskTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527f2f3",
  null
  
)

export default component.exports